/** Normalize a US phone number to E.164, or return an empty string if invalid. */
export function normalizeUsPhone(input: string): string {
  const digits = input.replace(/\D/g, '')
  const nationalNumber = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits

  return nationalNumber.length === 10 ? `+1${nationalNumber}` : ''
}
